import { memo } from 'react';
import { Node, NodeProps } from '@xyflow/react';
import { ClinicalSpecialistIcon, SurgeonIcon } from '@icons';
import { RouteChildNodeDataType, RouteNodeType } from '@lp/features/RoutePlanner/types';
import { CaseResourceType } from '@/api/apis/case';
import { NodeHandleConnections } from './NodeHandleConnections';

export type ResourceNodeProps = Node<RouteNodeType<RouteChildNodeDataType>['data'], 'resourceNode'>;

export const ResourceNode = memo(({ data }: NodeProps<ResourceNodeProps>) => {
  const { resource, title } = data;

  return (
    <NodeHandleConnections>
      <div className="flex justify-center items-center bg-transparent gap-1 border-1 border-base-30 pl-0 pr-0.5 rounded-sm text-base-30">
        {resource === CaseResourceType.ClinicalSpecialist && <ClinicalSpecialistIcon width={12} height={12} />}
        {resource === CaseResourceType.Surgeon && <SurgeonIcon width={12} height={12} />}
        <span className="font-mono text-s-sb uppercase">{title}</span>
      </div>
    </NodeHandleConnections>
  );
});
